<template>
  <div class="home">
    <div
      id="header"
      class="header header-fixed"
      :class="{ 'header-light': headerLight }"
    >
      <div class="inner">
        <div class="row header-row">
          <div class="header-logo">
            <a class="logo iconfont icon-logo" href="/"> </a>
          </div>
          <div class="header-other">
            <div class="">
              <div class="menu" id="menu">
                <ul>
                  <li class="selected">
                    <a href="/">首页</a>
                  </li>
                  <li class="">
                    <router-link to="/admaster" class="menu-item"
                      >产品服务
                      <ul class="sub-menu">
                        <div class="arrow"></div>
                        <li>
                          <router-link
                            target="_blank"
                            to="/"
                            class="sub-menu-item"
                            >广告监测</router-link
                          >
                        </li>
                        <li>
                          <router-link
                            to="/ip"
                            class="sub-menu-item"
                            style="text-decoration: none; color: #666"
                            >综合定位服务</router-link
                          >
                        </li>
                      </ul>
                    </router-link>
                  </li>
                  <li class="">
                    <a href="https://www.admobile.top/aboutus.html">关于我们</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="">
              <div class="user-center">
                <router-link
                  v-if="!isLogin"
                  class="button button-light"
                  id="login"
                  :to="{ path: '/login' }"
                  >登录</router-link
                >
                <div v-else class="user-info">
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      {{ userInfo.username }}
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>
                        <!-- <span @click="dialogVisible = true">用户中心</span> -->
                        <router-link to="/user">用户中心</router-link>
                      </el-dropdown-item>
                      <el-dropdown-item divided>
                        <span @click="logout">退出</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="menu-close" id="menuIcon">
        <span class="menu-close-top"></span>
        <span class="menu-close-middle"></span>
        <span class="menu-close-bottom"></span>
      </div>
    </div>
    <div id="container">
      <div class="top-banner" id="focus" :style="{ height: bannerHeight }">
        <div class="focus-image"></div>
        <div class="inner">
          <div class="enter-btn" @click="enter">立即体验</div>
        </div>
      </div>

      <section class="section product-data" id="productData">
        <div class="inner">
          <div class="box-list">
            <div class="box-item animation-left">
              <div class="box-item-body machine-num">
                <div class="box-content">
                  <div class="data"><em>4亿</em>+</div>
                  <div class="field">设备覆盖量</div>
                </div>
              </div>
            </div>
            <div class="box-item animation-left">
              <div class="box-item-body material-num">
                <div class="box-content">
                  <div class="data"><em>1400w</em>+</div>
                  <div class="field">素材数量</div>
                </div>
              </div>
            </div>
            <div class="box-item animation-left">
              <div class="box-item-body app-num">
                <div class="box-content">
                  <div class="data"><em>10W</em>+</div>
                  <div class="field">移动App数量</div>
                </div>
              </div>
            </div>
            <div class="box-item animation-left">
              <div class="box-item-body admaster-num">
                <div class="box-content">
                  <div class="data"><em>8000</em>+</div>
                  <div class="field">广告主数量</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section product-server" id="productServer">
        <div class="inner">
          <div class="product-slide">
            <el-carousel trigger="click" @change="changeTxt" ref="carousel">
              <el-carousel-item>
                <img src="../assets/img/home/home_main2_img1@1x.png" />
              </el-carousel-item>
              <el-carousel-item>
                <img src="../assets/img/home/home_main2_img2@1x.png" />
              </el-carousel-item>
              <el-carousel-item>
                <img src="../assets/img/home/home_main2_img3@1x.png" />
              </el-carousel-item>
              <el-carousel-item>
                <img src="../assets/img/home/home_main2_img4@1x.png" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="product-info-box">
            <div class="product-info animation-left">
              <div class="slide-wrapper">
                <div class="slide-item" :class="{ active: isActive == 0 }">
                  <div class="product-title">广告素材监测分析</div>
                  <ul class="list">
                    <li>实时广告监测，日均数据增量10w+</li>
                    <li>海量去重素材，助力挖掘优质创意</li>
                    <li>国内独有点击率及设备数据，多维度洞察买量情报</li>
                  </ul>
                </div>
                <div class="slide-item" :class="{ active: isActive == 1 }">
                  <div class="product-title">行业分析</div>
                  <ul class="list">
                    <li>深挖行业情报，洞悉市场动态</li>
                    <li>综合分析行业广告受众，调整投放方向</li>
                  </ul>
                </div>
                <div class="slide-item" :class="{ active: isActive == 2 }">
                  <div class="product-title">广告主榜单</div>
                  <ul class="list">
                    <li>多维度买量数据，跟踪竞品动向</li>
                    <li>掌握同行投放力度，优化投放策略</li>
                  </ul>
                </div>
                <div class="slide-item" :class="{ active: isActive == 3 }">
                  <div class="product-title">爆款文案</div>
                  <ul class="list">
                    <li>热门文案推荐，把握优质文案核心关键词</li>
                    <li>关联素材数据，提供爆款创意参考</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="control-btns">
            <img
              src="../assets/img/home/home_main2_btnl@1x.png"
              alt=""
              @click="prev"
            />
            <img
              src="../assets/img/home/home_main2_btnr@1x.png"
              alt=""
              @click="next"
            />
          </div>
        </div>
      </section>

      <section class="section partner" id="partner">
        <div class="inner">
          <div class="section-header">
            <div class="section-header-title">合作伙伴</div>
          </div>
          <ul class="image-list">
            <li><img src="../assets/img/partner/变现猫@1x.png" /></li>
            <li><img src="../assets/img/partner/苍崎科技@1x.png" /></li>
            <li><img src="../assets/img/partner/个推@1x.png" /></li>
            <li><img src="../assets/img/partner/惊瑜科技@1x.png" /></li>
            <li><img src="../assets/img/partner/聚量@1x.png" /></li>
            <li><img src="../assets/img/partner/芒果@1x.png" /></li>
            <li><img src="../assets/img/partner/省广畅思@1x.png" /></li>
            <li><img src="../assets/img/partner/天天看看@1x.png" /></li>
            <li><img src="../assets/img/partner/inmobi@1x.png" /></li>
            <li><img src="../assets/img/partner/Mobvista@1x.png" /></li>
            <li><img src="../assets/img/partner/qd_lenovo、@1x.png" /></li>
            <li><img src="../assets/img/partner/qd_yd备份@1x.png" /></li>
          </ul>
        </div>
      </section>
    </div>
    <div class="w-gotop" style="display: none">
      <i class="iconfont icon-up"></i>
    </div>
    <Footer></Footer>
    <el-dialog title="用户中心" :visible.sync="dialogVisible" width="30%">
      <div class="userinfo-dialog">
        <p>
          <span class="label">用户ID：</span>
          <span class="value">{{ userInfo.id }}</span>
        </p>
        <p>
          <span class="label">用户名：</span>
          <span class="value">{{ userInfo.username }}</span>
        </p>
        <p>
          <span class="label">过期时间：</span>
          <span class="value">{{ userInfo.expirydate }}</span>
        </p>
      </div>
    </el-dialog>
    <div class="customer-service">
      <div class="icon">
        <img src="../assets/img/customer_service.svg" alt="" />
      </div>

      <div class="contact-info">
        <div class="contact-icon contact-icon-qq" @click="openQQ">
          <img src="../assets/img/qq.svg" alt="" />
          <span>QQ客服</span>
        </div>
        <div class="contact-icon">
          <img src="../assets/img/weixin.png" alt="" />
          <span>微信客服</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from "../components/Footer";
export default {
  name: "Home",
  components: { Footer },
  mounted() {
    let session = this.$route.query["session"];
    if (!!session) {
      localStorage.setItem("session", session);
      localStorage.setItem("isLogin", "1");
    }
    this.session = localStorage.getItem("session");
    let isLogin = localStorage.getItem("isLogin");
    this.isLogin = isLogin;
    this.queryUserINfo();
    this.bannerHeight = (document.body.clientWidth * 100) / 288 + "px";
  },
  data() {
    return {
      isLogin: false,
      userInfo: {},
      headerLight: false,
      isActive: 0,
      session: "",
      dialogVisible: false,
      bannerHeight: "500px",
    };
  },
  methods: {
    scroll() {
      console.log(window.scrollY);
      if (window.scrollY > 80) {
        this.headerLight = true;
      } else {
        this.headerLight = false;
      }
    },
    changeTxt(index) {
      console.log(index);
      this.isActive = parseInt(index);
    },
    prev() {
      this.$refs.carousel.prev();
    },
    next() {
      this.$refs.carousel.next();
    },
    queryUserINfo() {
      if (this.isLogin) {
        this.$http.get("/fireeye/account/info").then((res) => {
          console.log(res);
          let data = res.data;
          if (data.code == 1) {
            this.userInfo = data.data;
            this.$root.status = this.userInfo.status;
            window.localStorage.setItem(
              "status",
              this.userInfo.status.toString()
            );
          } else {
            console.log("获取用户信息失败");
          }
        });
      }
    },
    logout() {
      let session = localStorage.getItem("session");
      window.localStorage.removeItem("isLogin");
      window.localStorage.removeItem("session");
      this.$root.isLogin = false;
      this.isLogin = false;
      console.log(this.isLogin);
      let http = this.$http.create();
      http.defaults.headers.common["Content-Type"] =
        "application/x-www-form-urlencoded";
      http.post("/fireeye/account/logout?session=" + session).then((res) => {
        console.log(res);
        if (this.$route.path != "/") {
          this.$router.push("/login");
        }
      });
    },
    enter() {
      if (this.isLogin) {
        this.$router.push("/admaster");
      } else {
        this.$router.push("/login");
      }
    },
    openQQ() {
      window.open(
        "https://wpa.qq.com/msgrd?v=3&uin=258620589&site=qq&menu=yes",
        { target: "_blank" }
      );
    },
  },
};
</script>


</style>
<style lang="less" scoped>
.home {
  background: linear-gradient(180deg, #05061b 0%, #00070e 100%);
}
.header {
  a {
    color: #fff;
  }
}
.header-row {
  display: flex;
  justify-content: space-between;
  width: 1200px;

  .header-logo {
    width: 180px;
  }
  .header-other {
    flex: 1;
    justify-content: space-between;
    display: flex;
  }
}
.user-center {
  width: 180px;
}
.user-info {
  display: inline-block;
  line-height: 70px;

  .el-dropdown-link {
    font-size: 18px;
  }
}
.el-dropdown-menu {
  li {
    span,
    a {
      padding: 3px 20px;
      display: block;
      color: #606266;
    }
  }
}
.el-dropdown-menu__item--divided:before {
  height: 1px;
  margin: 0;
}
.section {
  width: 1200px;
  margin: 0 auto;
}
.section-content {
  display: flex;
}
.slide-item {
  display: none;
}
.slide-item.active {
  display: block;
}

.container {
  margin: 0 auto;
}
.enter-btn {
  margin-left: 130px;
  cursor: pointer;
}
.footer {
  overflow: hidden;
  font-family: PingFangSC-Medium, PingFang SC;

  .footer-logo {
    width: 250px;
    height: 70px;
    margin: 32px auto 0;
  }

  .footer-title {
    font-size: 20px;
    font-weight: 500;
    color: #ffffff;
    line-height: 28px;
    margin-top: 24px;
  }
  .title {
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    line-height: 22px;
    margin: 46px 0 24px 0;
  }

  .nav {
    text-align: left;

    .nav-link,
    .info {
      display: block;
      text-decoration: none;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      margin-bottom: 16px;
    }
    .info {
      margin-bottom: 16px;
    }
  }

  .site-info {
    font-weight: 400;
    text-align: center;
    margin: 80px auto 40px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #ffffff;
    line-height: 20px;

    a {
      text-decoration: none;
      color: #ffffff;
    }
  }
}
.customer-service {
  position: fixed;
  z-index: 999;
  right: 50px;
  bottom: 100px;
  .icon {
    padding-left: 20px;

    img {
      box-sizing: border-box;
      background-color: #fff;
      width: 50px;
      text-align: center;
      padding: 10px;
      box-shadow: 1px 1px 5px #bbb;
    }
  }
  .contact-info {
    display: none;
    position: absolute;
    top: -80px;
    left: -80px;
    box-shadow: 1px 1px 5px #999;
    padding: 5px 0;
    background-color: #fff;
    font-size: 14px;
  }
  .contact-icon {
    background-color: #fff;
    text-align: center;
    img {
      display: block;
      box-sizing: border-box;
      background-color: #fff;
      width: 80px;
      text-align: center;
      padding: 10px;
    }
  }
  .contact-icon-qq {
    border-bottom: 1px solid #ddd;
    cursor: pointer;
  }
}
.customer-service:hover {
  .contact-info {
    display: block;
  }
}

.header .inner .menu .menu-item.active {
  color: #e98652;
}

.header .inner .menu .sub-menu {
  position: absolute;
  left: 0px;
  top: 70px;
  display: none;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 16px;
  font-weight: normal;
  width: 120px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0px 0px 20px #999;
  text-align: left;
}

// menu
.menu .sub-menu .arrow {
  width: 0;
  height: 0;
  border: 10px solid #fff;
  border-top-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  position: absolute;
  top: -18px;
  left: 50px;
}

.menu .sub-menu li {
  line-height: 50px;
}

.menu .sub-menu-item {
  text-decoration: none;
  padding: 10px 16px;
  color: #000;
  font-size: 14px;
  font-weight: 600;
}

.menu .sub-menu-item:hover {
  text-decoration: none;
  padding: 10px 16px;
  color: #666;
}

.menu .menu-item:hover {
  color: #666;
}

.menu .menu-item:hover > .sub-menu {
  display: block;
}
</style>
<style scoped src="../assets/css/common.css"></style>
<style scoped src="../assets/css/header.css"></style>
<style scoped src="../assets/css/home.css"></style>
<style scoped src="../assets/css/index.css"></style>